import React from 'react';
import Select from 'react-select';
import './select_check.css';
import style from './selectcheck.module.css';

export default function SelectCheck({ label, isMulti, options, onChange, value, placeholder }) {
    return (
        <div className={style.select_smeta_block}>
            <label>{label}</label>
            <Select
                isMulti={isMulti}
                className="SelectCheck"
                options={options}
                onChange={onChange}
                value={value}
                placeholder={placeholder}
            />
        </div>
    );
}
